let entrepreneurSelect;
let companySelect;
let shareItems;

document.addEventListener('DOMContentLoaded', function(){

  entrepreneurSelect = document.querySelector('.successtory-selector');
  if(entrepreneurSelect){
    entrepreneurSelect.addEventListener('change', function(){
      loadStory(this.value);
    });
  }

  companySelect = document.querySelector('.company-selector');
  if(companySelect){
    companySelect.addEventListener('change', function(){
      loadStory(this.value);
    });
  }

  shareItems = document.querySelectorAll('.share-items button');
  if(shareItems && shareItems.length > 0){

    shareItems.forEach(function(item){

      item.addEventListener('click', function(e){
        
        e.preventDefault();

        var $this = this;
        var shareUrl = $this.getAttribute('data-share-url');
        var url = $this.getAttribute('data-url');

        createPopup(shareUrl+url);

      });

    });

  }

});

let loadStory = function(href){
  window.location.href = href;
}

let createPopup = function(url){

  window.open(
    url,
    'sharer',
    'toolbar=0,status=0,width=636,height=665'
  );

}



// WEBPACK FOOTER //
// ./scripts/autoload/_stories.js